import HttpService from "./HttpService";

const MCEEResultService = () => {
  return Object.freeze({
    saveScore: async (data) => {
      return HttpService().postRequest(data, "/mcee/result");
    }
  });
};

export default MCEEResultService;
